document.addEventListener('DOMContentLoaded', () => {
  const menuToggle = document.querySelector('[data-hi-menu-toggle]');
  const menuPanel = document.querySelector('[data-hi-menu-panel]');

  if (menuToggle && menuPanel) {
    menuToggle.addEventListener('click', () => {
      const isOpen = menuToggle.getAttribute('aria-expanded') === 'true';
      menuToggle.setAttribute('aria-expanded', String(!isOpen));
      menuPanel.hidden = isOpen;
      document.body.classList.toggle('hi-menu-open', !isOpen);
    });
  }

  document.querySelectorAll('[data-hi-product-root]').forEach((root) => {
    const items = [...root.querySelectorAll('[data-hi-media-item]')];
    const viewerItems = [...root.querySelectorAll('[data-hi-viewer-item]')];
    const thumbs = [...root.querySelectorAll('[data-hi-thumb]')];
    const viewer = root.querySelector('[data-hi-viewer]');
    const closeBtn = root.querySelector('[data-hi-viewer-close]');
    const prevBtn = root.querySelector('[data-hi-viewer-prev]');
    const nextBtn = root.querySelector('[data-hi-viewer-next]');
    const stage = root.querySelector('[data-hi-media-stage]');
    const variantButtons = [...root.querySelectorAll('[data-hi-variant-button]')];
    const variantInput = root.querySelector('[data-hi-variant-input]');
    const priceTarget = root.querySelector('[data-hi-price]');
    const addBtn = root.querySelector('[data-hi-add-button]');

    let currentIndex = 0;

    function setActiveIndex(index) {
      currentIndex = index;
      items.forEach((item, itemIndex) => item.classList.toggle('is-active', itemIndex === index));
      viewerItems.forEach((item, itemIndex) => item.classList.toggle('is-active', itemIndex === index));
      thumbs.forEach((thumb, thumbIndex) => thumb.classList.toggle('is-active', thumbIndex === index));
    }

    function openViewer() {
      if (!viewer) return;
      viewer.hidden = false;
      document.body.classList.add('hi-viewer-open');
    }

    function closeViewer() {
      if (!viewer) return;
      viewer.hidden = true;
      document.body.classList.remove('hi-viewer-open');
    }

    function shiftViewer(step) {
      if (!items.length) return;
      let nextIndex = currentIndex + step;
      if (nextIndex < 0) nextIndex = items.length - 1;
      if (nextIndex >= items.length) nextIndex = 0;
      setActiveIndex(nextIndex);
    }

    thumbs.forEach((thumb, index) => {
      thumb.addEventListener('click', () => setActiveIndex(index));
    });

    if (stage) stage.addEventListener('click', openViewer);
    if (closeBtn) closeBtn.addEventListener('click', closeViewer);
    if (prevBtn) prevBtn.addEventListener('click', () => shiftViewer(-1));
    if (nextBtn) nextBtn.addEventListener('click', () => shiftViewer(1));

    if (viewer) {
      viewer.addEventListener('click', (event) => {
        if (event.target === viewer) closeViewer();
      });
    }

    variantButtons.forEach((button) => {
      button.addEventListener('click', () => {
        variantButtons.forEach((item) => item.classList.remove('is-active'));
        button.classList.add('is-active');

        if (variantInput) variantInput.value = button.dataset.variantId;
        if (priceTarget && button.dataset.price) priceTarget.textContent = button.dataset.price;

        if (addBtn) {
          const available = button.dataset.available === 'true';
          addBtn.disabled = !available;
          addBtn.textContent = available ? 'Add To Bag' : 'Sold Out';
        }

        const mediaId = button.dataset.mediaId;
        if (mediaId) {
          const mediaIndex = thumbs.findIndex((thumb) => thumb.dataset.mediaId === mediaId);
          if (mediaIndex >= 0) setActiveIndex(mediaIndex);
        }
      });
    });

    document.addEventListener('keydown', (event) => {
      if (!viewer || viewer.hidden) return;
      if (event.key === 'Escape') closeViewer();
      if (event.key === 'ArrowLeft') shiftViewer(-1);
      if (event.key === 'ArrowRight') shiftViewer(1);
    });

    setActiveIndex(0);
  });

  document.querySelectorAll('[data-hi-hero-slider]').forEach((slider) => {
    const slides = [...slider.querySelectorAll('[data-hi-hero-slide]')];
    const indicators = [...slider.querySelectorAll('[data-hi-hero-indicator]')];
    const progress = slider.querySelector('[data-hi-hero-progress]');
    const intervalMs = Number(slider.dataset.interval || 5000);
    let currentIndex = 0;
    let timer = null;

    if (!slides.length) return;

    function startProgress() {
      if (!progress) return;
      progress.style.animation = 'none';
      void progress.offsetWidth;
      progress.style.animation = `hi-progress ${intervalMs}ms linear forwards`;
    }

    function setSlide(index) {
      currentIndex = index;
      slides.forEach((slide, slideIndex) => {
        slide.classList.toggle('is-active', slideIndex === index);
      });
      indicators.forEach((indicator, indicatorIndex) => {
        indicator.classList.toggle('is-active', indicatorIndex === index);
      });
      startProgress();
    }

    function restartTimer() {
      if (timer) clearInterval(timer);
      timer = setInterval(() => {
        const next = (currentIndex + 1) % slides.length;
        setSlide(next);
      }, intervalMs);
    }

    indicators.forEach((indicator) => {
      indicator.addEventListener('click', () => {
        const target = Number(indicator.dataset.hiHeroIndicator || 0);
        setSlide(target);
        restartTimer();
      });
    });

    setSlide(0);
    restartTimer();
  });

  document.querySelectorAll('[data-hi-catalog]').forEach((catalog) => {
    const filterButtons = [...catalog.querySelectorAll('[data-hi-filter]')];
    const sortSelect = catalog.querySelector('[data-hi-sort]');
    const grid = catalog.querySelector('[data-hi-catalog-grid]');
    const cards = grid ? [...grid.querySelectorAll('[data-hi-card]')] : [];
    const desktopLimit = Number(catalog.dataset.hiDesktopLimit || 8);
    const mobileLimit = Number(catalog.dataset.hiMobileLimit || 4);
    let activeFilter = 'all';

    if (!grid || !cards.length) return;

    function getLimit() {
      return window.matchMedia('(max-width: 767px)').matches ? mobileLimit : desktopLimit;
    }

    function applyFilter() {
      cards.forEach((card) => {
        const category = card.dataset.category || '';
        const tags = (card.dataset.tags || '').split(',').map((tag) => tag.trim());
        const visible = activeFilter === 'all' || category === activeFilter || tags.includes(activeFilter);
        card.classList.toggle('is-filter-hidden', !visible);
      });
    }

    function applySort() {
      const sortValue = sortSelect ? sortSelect.value : 'featured';
      const visibleCards = cards.filter((card) => !card.classList.contains('is-filter-hidden'));
      const hiddenCards = cards.filter((card) => card.classList.contains('is-filter-hidden'));

      visibleCards.sort((a, b) => {
        const aPrice = Number(a.dataset.price || 0);
        const bPrice = Number(b.dataset.price || 0);
        const aFeatured = Number(a.dataset.featured || 999);
        const bFeatured = Number(b.dataset.featured || 999);

        if (sortValue === 'low') return aPrice - bPrice;
        if (sortValue === 'high') return bPrice - aPrice;
        return aFeatured - bFeatured;
      });

      [...visibleCards, ...hiddenCards].forEach((card) => grid.appendChild(card));
    }

    function applyLimit() {
      const limit = getLimit();
      let visibleCount = 0;

      cards.forEach((card) => {
        if (card.classList.contains('is-filter-hidden')) {
          card.classList.add('is-limit-hidden');
          return;
        }

        visibleCount += 1;
        card.classList.toggle('is-limit-hidden', visibleCount > limit);
      });
    }

    function refresh() {
      applyFilter();
      applySort();
      applyLimit();
    }

    filterButtons.forEach((button) => {
      button.addEventListener('click', () => {
        activeFilter = button.dataset.hiFilter || 'all';
        filterButtons.forEach((item) => item.classList.remove('is-active'));
        button.classList.add('is-active');
        refresh();
      });
    });

    if (sortSelect) {
      sortSelect.addEventListener('change', refresh);
    }

    let resizeTimer;
    window.addEventListener('resize', () => {
      window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(refresh, 120);
    });

    refresh();
  });

  // Category carousel
  document.querySelectorAll('[data-hi-category-carousel]').forEach(carousel => {
    const wrap = carousel.closest('.hi-category-wrap');
    const btnNext = wrap && wrap.querySelector('[data-hi-cat-next]');
    const btnPrev = wrap && wrap.querySelector('[data-hi-cat-prev]');

    const scrollAmount = () => {
      const tile = carousel.querySelector('.hi-category-tile');
      return tile ? tile.offsetWidth + 8 : 300;
    };

    if (btnNext) btnNext.addEventListener('click', () => carousel.scrollBy({ left: scrollAmount(), behavior: 'smooth' }));
    if (btnPrev) btnPrev.addEventListener('click', () => carousel.scrollBy({ left: -scrollAmount(), behavior: 'smooth' }));

    // Drag to scroll
    let isDragging = false, startX, scrollLeft;
    carousel.addEventListener('mousedown', e => {
      isDragging = true;
      startX = e.pageX - carousel.offsetLeft;
      scrollLeft = carousel.scrollLeft;
    });
    carousel.addEventListener('mouseleave', () => { isDragging = false; });
    carousel.addEventListener('mouseup', () => { isDragging = false; });
    carousel.addEventListener('mousemove', e => {
      if (!isDragging) return;
      e.preventDefault();
      carousel.scrollLeft = scrollLeft - (e.pageX - carousel.offsetLeft - startX) * 1.5;
    });
  });

  // Featured carousel
  document.querySelectorAll('[data-hi-featured-carousel]').forEach((carousel) => {
    const wrap = carousel.closest('.hi-featured-carousel-wrap');
    const btnNext = wrap && wrap.querySelector('[data-hi-featured-next]');
    const btnPrev = wrap && wrap.querySelector('[data-hi-featured-prev]');

    const scrollAmount = () => {
      const slide = carousel.querySelector('.hi-featured-slide');
      return slide ? slide.offsetWidth + 12 : carousel.clientWidth;
    };

    if (btnNext) {
      btnNext.addEventListener('click', () => {
        carousel.scrollBy({ left: scrollAmount(), behavior: 'smooth' });
      });
    }
    if (btnPrev) {
      btnPrev.addEventListener('click', () => {
        carousel.scrollBy({ left: -scrollAmount(), behavior: 'smooth' });
      });
    }

    let isDragging = false;
    let startX = 0;
    let scrollLeft = 0;

    carousel.addEventListener('mousedown', (event) => {
      isDragging = true;
      startX = event.pageX - carousel.offsetLeft;
      scrollLeft = carousel.scrollLeft;
    });
    carousel.addEventListener('mouseleave', () => { isDragging = false; });
    carousel.addEventListener('mouseup', () => { isDragging = false; });
    carousel.addEventListener('mousemove', (event) => {
      if (!isDragging) return;
      event.preventDefault();
      carousel.scrollLeft = scrollLeft - (event.pageX - carousel.offsetLeft - startX) * 1.35;
    });
  });
});
